/*=========================================================================================
  File Name: moduleAuth.js
  Description: Auth Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleAuthState'
import mutations from './moduleAuthMutations'
import actions from './moduleAuthActions'
import getters from './moduleAuthGetters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}